module.exports = __webpack_public_path__ + "img/influx-logo.dcd757cc.png";